

























import Vue from 'vue';
import { Component, Inject, Watch } from 'vue-property-decorator';

@Component
export default class Message extends Vue {
    @Inject() eventBus!: Vue;
    output = '';
    isShowKeyboard = false;
    note = '';

    @Watch ('note')
    watchNote(value: string){
        this.$emit('updateNote',this.note)
    }

    get selectedDate() {
        return this.$store.state.selectedDate;
    }

    get currentTime() {
        return this.$store.state.currentTime;
    }


    mounted() {
        this.eventBus.$emit('initOutput', this.output);
        this.eventBus.$on('updateOutput', (output: string) => {
            this.output = output;
            this.$emit('updateOutput',output)
        });
        this.eventBus.$on('reset',()=>{
            this.output = ''
            this.note = ''
        })
    }

    showKeyboard() {
        this.isShowKeyboard = true;
        this.$emit('updateShowKeyboard', this.isShowKeyboard);

    }

}
